package org.vreo.devicehub.features.device.presentation.deviceManagement.mainDeviceNavigation

/**
 * Device management actions
 */
sealed interface DeviceManagementActions {
    data object OnBackNavigation : DeviceManagementActions
    data class OnUpdateTabIndex(val index: Int) : DeviceManagementActions
}